import React, { useContext } from 'react';
import GitRepositoriesTable from '../../components/GitRepositoriesTable';
import GitUsersTable from '../../components/GitUsersTable';
import GitSettings from '../../components/GitSettings';
import GitStatsDashboard from '../../components/GitStatsDashboard';
import GitMonitorDashboard from '../../components/GitMonitorDashboard';
import QuotaManagement from '../QuotaManagement/QuotaManagement';
import { Tab, Icon, Message, Container } from 'semantic-ui-react';
import { StatusContext } from '../../context/Status';

const Git = () => {
  const [statusState] = useContext(StatusContext);
  const gitEnabled = statusState?.status?.git_enabled !== false;

  // 如果 Git 功能被禁用，显示提示信息
  if (!gitEnabled) {
    return (
      <Container style={{ marginTop: '2em' }}>
        <Message warning icon>
          <Icon name='warning sign' />
          <Message.Content>
            <Message.Header>Git 功能未启用</Message.Header>
            <p>当前系统配置中 Git 功能已被禁用。如需使用 Git 仓库管理功能，请联系系统管理员启用 GIT_ENABLED 配置项。</p>
          </Message.Content>
        </Message>
      </Container>
    );
  }

  const panes = [
    {
      menuItem: { key: 'stats', icon: 'chart bar', content: '统计概览' },
      render: () => (
        <Tab.Pane>
          <GitStatsDashboard />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'monitor', icon: 'dashboard', content: '监控中心' },
      render: () => (
        <Tab.Pane>
          <GitMonitorDashboard />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'repos', icon: 'folder', content: '仓库管理' },
      render: () => (
        <Tab.Pane>
          <GitRepositoriesTable />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'users', icon: 'users', content: '用户统计' },
      render: () => (
        <Tab.Pane>
          <GitUsersTable />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'quota', icon: 'balance scale', content: '配额管理' },
      render: () => (
        <Tab.Pane>
          <QuotaManagement />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'settings', icon: 'setting', content: '系统设置' },
      render: () => (
        <Tab.Pane>
          <GitSettings />
        </Tab.Pane>
      )
    }
  ];

  return <Tab panes={panes} />;
};

export default Git; 